export async function fileToBase64(file: File): Promise<string> {
  if (Object.keys(file).length === 0 && file.constructor === Object) {
    return "";
  }
  const base64 = await new Promise((resolve) => {
    const fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.readAsDataURL(file);
  });
  return String(base64);
}
